import ActivityIcon from "icons/ActivityIcon";
import { TextData } from "views/components/Schedules/components/UpdateActivityPopup/styles";
import { Container } from "./styles";
import { FieldIconWrapper } from "views/components/Schedules/styles";

const SpaceReservationActivity = ({
	activity
}) => {
	return (
		<Container>
			<FieldIconWrapper>
				<ActivityIcon/>
			</FieldIconWrapper>
			<TextData>{activity}</TextData>
		</Container>
	);
}

export default SpaceReservationActivity;